import { render, staticRenderFns } from "./import-lead.vue?vue&type=template&id=2eb43c2e"
import script from "./import-lead.vue?vue&type=script&lang=js"
export * from "./import-lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports